import { KeyDialog, KeyForm, useEditKey } from 'app/domains/api-management';
export function EditKeyForm(props) {
    const { onClose, initialValues, id } = props;
    const { editKey, data, reset } = useEditKey();
    const handleClose = () => {
        onClose();
        reset();
    };
    if (data) {
        return <KeyDialog apiKey={data} onClose={handleClose}/>;
    }
    return (<KeyForm onSubmit={form => editKey({ id, input: form })} initialValues={initialValues} onClose={onClose}/>);
}
